import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-bar-vertical',
  templateUrl: './bar-vertical.component.html',
  styleUrls: ['./bar-vertical.component.scss']
})
export class BarVerticalComponent implements AfterViewInit {
  chartBarVertical: any;
  data ;
  data1 ;
  datasets ;
  datasetsOn ;
  showPanelProperties =  false; // propiedad permite visualizar sidebar
  showTableTmp: boolean = false; // propiedad permite visualizar la tabla
  @Input() showTable: boolean = false; // propiedad permite visualizar la tabla
  @Input() idElement = 'unknow';
  @Input() chartTitle = 'unknow';
  @Input() positionLegend: any =  {label: 'Arriba', code: 'top'}; // posicion de la leyenda
  @Input() AdditionalColorCard = "" ;

  cardMaximized = false; // indica el estado de la card del chart
  positionLegendList = [
  {label: 'Arriba', code: 'top'},
  {label: 'Izquierda', code: 'left'},
  {label: 'Abajo', code: 'bottom'},
  {label: 'Derecha', code: 'right'}];

 labels = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
 revenues = [
  20000,
  14000,
  12000,
  15000,
  18000,
  19000,
  22000
];
revenues1 = [
  2000,
  1400,
  1200,
  1500,
  8000,
  19000,
  20000
];
 clients = [
  120,
  140,
  80,
  150,
  190,
  170,
  202
];

  constructor() { console.log('construye obj')}

ngAfterViewInit(): void {

this.data = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [{
      label: '# of Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 1
  }]
};

this.datasets = [
  {
      type: 'line',
      label: "Revenues",
      data: this.revenues,
      borderColor: 'rgba(75, 192, 192, 1)',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      yAxisID: 'revenues',
      hidden: false,
  },
  {
    type: 'line',
    label: "Revenues1",
    data: this.revenues1,
    borderColor: 'rgba(0, 19, 192, 1)',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    yAxisID: 'revenues',
    hidden: false,
},
  {
      label: "Clients",
      data: this.clients,
      borderColor: 'rgba(0, 0, 0, 0)',
      backgroundColor: 'rgba(255, 206, 86, 0.5)',
      yAxisID: 'clients',
      hidden: false,
  }
];
this.data1 =  {
  labels: this.labels,
  datasets: this.datasets
};

this.loadAllData();
this.generateChart();
}

generateChart() {
this.chartBarVertical = new Chart('canvas-bar-vertical', {
    /*   type:'bar',
    data: {
      labels: ["Eating", "Drinking", "Sleeping", "Designing", "Coding", "Cycling", "Running"],
      datasets: [
          {
              label: "My First dataset",
              data: [65, 59, 90, 81, 56, 55, 40]
          },
          {
            label: "My Second dataset",
            data: [6, 29, 50, 61, 60, 50, 40]
        }
      ]
    }*/

    // mix de dos tipos
    /*type: 'bar',
    data: {
      datasets: [{
          label: 'Bar Dataset',
          data: [10, 20, 30, 40],
          // this dataset is drawn below
          order: 1
      }, {
          label: 'Line Dataset',
          data: [10, 10, 1, 25],
          type: 'line',
          // this dataset is drawn on top
          order: 2
      }],
      labels: ['January', 'February', 'March', 'April']
    }*/

        // con opciones de colores 
    /*type: 'horizontalBar',
    data: this.data,
    options: {
      scales: {
          offset : false,
          yAxes: [{
              ticks: {
                  beginAtZero: true
              }
          }],
          xAxes: [{
            gridLines: {
                offsetGridLines: true
            }
        }]
      }
      ,
    onClick: (event , element) => {
      if (element.length === 0) {return; }
      // console.log(event);
      console.log(element);
      console.log(this.data.datasets[element[0]._datasetIndex].data[element[0]._index]);
    }
    }*/
      // ************************


      type: 'bar',
      data: this.data1,
      options: {
          legend: {
            display: true,
            position: this.positionLegend.code,
            onHover: (event, legendItem) => {
             //  console.log('onHover: ' , legendItem);
            },
            onLeave: (event, legendItem) =>{
             //  console.log('onLeave: ' , legendItem);
            },
            onClick: (event, legendItem) => {

                const ci =  this.chartBarVertical;
                const index = legendItem.datasetIndex;
                const meta = ci.getDatasetMeta(index);
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                this.datasets[index].hidden = meta.hidden;
                ci.update();
                this.loadAllData();
            }
          },
          scales: {
              yAxes: [
                  {
                      id: "revenues",
                      ticks: {
                          beginAtZero: true,
                      },
                      scaleLabel: {
                          display: true,
                          labelString: 'Revenues (U$)'
                        }
                  },
                  {
                      id: "clients",
                      position: 'right',
                      ticks: {
                          beginAtZero: true,
                      },
                      scaleLabel: {
                          display: true,
                          labelString: 'Clients'
                        }
                  },
              ]
          },          
          onClick: (event , element) => {
            // console.log(element);
            // console.log(this.data.datasets[element[0]._datasetIndex].data[element[0]._index]);
          }
      }


    });
  }

  loadAllData() {
    this.datasetsOn = this.datasets.filter(item => item.hidden !== true);
  }

  getStateCard(e) {
    this.cardMaximized = e;
  }

  onApplyChanges() {
    this.chartBarVertical.destroy();
    this.showTable = this.showTableTmp;
    this.generateChart();
   // this.showPanelProperties = false;
  }

}
